import React from 'react';
import styles from './MessageError.module.scss';

const className = 'message-error';

type MessageErrorProps = {
  children?: React.ReactNode;
};

const MessageError: React.FC<MessageErrorProps> = ({
  children = 'Kombinasi username / password yang Anda masukan salah, silahkan ulangi',
}) => (
  <div className={styles[className]}>
    {children}
  </div>
);

export default MessageError;